import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { CardController } from 'src/app/shared/card.controller';
import { DateView } from 'src/core/ui/date.view';
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';
import { BrandEditorController } from 'src/app/general/brands/parts/brand-editor.controller';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { ProductTypeEditorController } from 'src/app/products/products/parts/product-type-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { SupplierEditorController } from 'src/app/products/suppliers/parts/supplier-editor.controller';
import { ProductProviderEditorController } from 'src/app/products/product-providers/parts/product-provider-editor.controller';

interface Props extends ComponentViewProps<PolicyRuleItem> {
	sections: string[];
	title: string;
	mode: ControlMode;
}

@observer
export class PolicyRuleFormView extends React.Component<Props, {}> {
	public render() {
		const { model, mode, setBusy, sections } = this.props;

		return (
			<div className="card">
				<Row gutter={16}>
					{
						sections.some(m => m === 'general') &&
						<Col xs={24} md={8}>
							<CardController
								icon="book"
								className="card-borderless"
								title="General information"
								mode={mode}>
								<Row>
									<Col xs={24}>
										<BrandEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.brandId}
											onChanged={(item) => {
												if (item != null) {
													model.brandId = item.id;
													model.brandName = item.name;
												} else {
													model.brandId = null;
													model.brandName = null;
												}
											}}
										/>
									</Col>
									<Col xs={24}>
										<MarketEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.marketId}
											onChanged={(item) => {
												if (item != null) {
													model.marketId = item.id;
													model.marketName = item.name;
												} else {
													model.marketId = null;
													model.marketName = null;
												}
											}}
										/>
									</Col>
									<Col xs={24}>
										<RegionEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.regionId}
											onChanged={(item) => {
												if (item != null) {
													model.regionId = item.id;
													model.regionDisplayName = item.displayName;
												} else {
													model.regionId = null;
													model.regionDisplayName = null;
												}
											}}
										/>
									</Col>
									{
										sections.some(m => m === 'product') &&
										<Col xs={24}>
											<PlaceEditorController
												mode={mode}
												setBusy={setBusy}
												value={model.placeId}
												onChanged={(item) => {
													if (item != null) {
														model.placeId = item.id;
														model.placeDisplayName = item.displayName;
													} else {
														model.placeId = null;
														model.placeDisplayName = null;
													}
												}}
											/>
										</Col>
									}
								</Row>
							</CardController>
						</Col>
					}
					{
						sections.some(m => m === 'product') &&
						<Col xs={24} md={8}>
							<CardController
								icon="shopping-cart"
								className="card-borderless"
								title="Product information"
								mode={mode}>
								<Row>
									<Col xs={24}>
										<ProductTypeEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.productType}
											onChanged={(item) => {
												if (item != null) {
													model.productCategoryId = null;
													model.productCategoryDisplayName = null;
													model.productId = null;
													model.productDisplayName = null;
													model.supplierId = null;
													model.supplierTitle = null;
													model.productProviderId = null;
													model.productProviderName = null;
													
													model.productType = item;
												}
												else {
													model.productType = null;
												}
												
											}}
										/>
									</Col>
									<Col xs={24}>
										<ProductCategoryEditorController
											mode={mode}
											productType={model.productType}
											setBusy={setBusy}
											value={model.productCategoryId}
											onChanged={(item) => {
												if (item != null) {

													model.productCategoryId = item.id;
													model.productId = null;
													model.productDisplayName = null;
													model.productCategoryDisplayName = item.displayName;
												} else {
													model.productCategoryId = null;
													model.productCategoryDisplayName = null;
												}
											}}
										/>
									</Col>
									<Col xs={24}>
										<ProductEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.productId}
											productType={model.productType}
											categoryId={model.productCategoryId}
											onChanged={(item) => {
												if (item != null) {
													model.productId = item.id;
													model.productDisplayName = item.displayName;
												} else {
													model.productId = null;
													model.productDisplayName = null;
												}
											}}
										/>
									</Col>
									<Col xs={24}>
										<SupplierEditorController
											mode={mode}
											setBusy={setBusy}
											value={model.supplierId}
											supplierType={model.productType == null ? null : (model.productType == 2) ? 1 : 0}
											onChange={(item: SupplierSummary) => {
												if (item != null) {
													model.supplierId = item.id;
													model.supplierTitle = item.title;
												} else {
													model.supplierId = null;
													model.supplierTitle = null;
												}
											}}
										/>
									</Col>
									<Col xs={24}>
										<ProductProviderEditorController
											label={"Product Provider"}
											mode={mode}
											onChange={(newValue) => {
												model.productProviderId = newValue ? newValue.id : null
												model.productProviderName = newValue ? newValue.name : null
											}}
											value={model.productProviderId}
											setBusy={setBusy}
											productType={model.productType}
										/>
									</Col>
								</Row>
							</CardController>
						</Col>
					}
					<Col xs={24} md={8}>
						<CardController
							icon="calendar"
							className="card-borderless"
							title="Dates information"
							mode={mode}>
							<Row>
								{
									sections.some(m => m === 'general') &&
									<React.Fragment>
										<Col xs={24}>
											<DateView
												label="Booking from"
												mode={mode}
												value={model.bookingDateFrom}
												onChanged={(newVal) => {
													model.bookingDateFrom = newVal;
												}}
												format="small-date"
												dateUsage="utc"
											/>
										</Col>
										<Col xs={24}>
											<DateView
												label="Booking to"
												mode={mode}
												value={model.bookingDateTo}
												onChanged={(newVal) => {
													model.bookingDateTo = newVal;
												}}
												format="small-date"
												dateUsage="utc"
											/>
										</Col>
									</React.Fragment>
								}
								{
									sections.some(m => m === 'product') &&
									<React.Fragment>
										<Col xs={24}>
											<DateView
												label="Service from"
												mode={mode}
												value={model.serviceDateFrom}
												onChanged={(newVal) => {
													model.serviceDateFrom = newVal;
												}}
												format="small-date"
												dateUsage="utc"
											/>
										</Col>
										<Col xs={24}>
											<DateView
												label="Service to"
												mode={mode}
												value={model.serviceDateTo}
												onChanged={(newVal) => {
													model.serviceDateTo = newVal;
												}}
												format="small-date"
												dateUsage="utc"
											/>
										</Col>
									</React.Fragment>
								}
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policy-rules/form/policy-rule-form.view.tsx